import { PessoaEnderecoModel } from "api/cardapio/models/pessoa/pessoa-model";
import { EnumOpcoesDelivery } from "storage";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IDadosDeliveryStore {
    empresaId: string;
    enderecoDelivery: PessoaEnderecoModel | undefined;
    tipoDelivery: EnumOpcoesDelivery | undefined;
    dadosWhatsapp: {
        telefone: string
        nome: string
        documento: string
    } | undefined
    setEmpresaId: (empresaId: string) => void,
    setEnderecoDelivery: (enderecoDelivery: PessoaEnderecoModel | undefined) => void,
    setTipoDelivery: (tipoDelivery: EnumOpcoesDelivery | undefined) => void,
    setDadosWhatsapp: (dadosWhatsapp: { telefone: string, nome: string, documento: string }) => void,
}

export const useDadosDeliveryStore = create<IDadosDeliveryStore>()(
    persist((set) => ({
        empresaId: '',
        enderecoDelivery: undefined,
        tipoDelivery: undefined,
        dadosWhatsapp: undefined,
        setEmpresaId: (empresaId: string) => set({ empresaId }),
        setEnderecoDelivery: (enderecoDelivery: PessoaEnderecoModel | undefined) => set({ enderecoDelivery }),
        setTipoDelivery: (tipoDelivery: EnumOpcoesDelivery | undefined) => set({ tipoDelivery }),
        setDadosWhatsapp: (dadosWhatsapp: { telefone: string, nome: string, documento: string }) => set({ dadosWhatsapp }),
    }), {
        name: 'dados-delivery',
        partialize: (state) => ({ enderecoDelivery: state.enderecoDelivery, tipoDelivery: state.tipoDelivery, dadosWhatsapp: state.dadosWhatsapp }),
    })
);